module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4c262586"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 164
// module chunks = 1